import React, {createContext, useCallback, useContext, useState} from 'react'

interface ICorrespondenceChatContext {
  isOpen: boolean
  open: (threadId?: string) => void
  close: () => void
  activeThreadId: string | null
  setActiveThreadId: (id: string | null) => void
}

const CorrespondenceChatContext = createContext<ICorrespondenceChatContext | null>(null)

export const CorrespondenceChatProvider: React.FC<{children: React.ReactNode}> = ({children}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [activeThreadId, setActiveThreadId] = useState<string | null>(null)

  const open = useCallback((threadId?: string) => {
    if (threadId) setActiveThreadId(threadId)
    setIsOpen(true)
  }, [])

  const close = useCallback(() => {
    setIsOpen(false)
    setActiveThreadId(null)
  }, [])

  return (
    <CorrespondenceChatContext.Provider
      value={{isOpen, open, close, activeThreadId, setActiveThreadId}}
    >
      {children}
    </CorrespondenceChatContext.Provider>
  )
}

export function useCorrespondenceChat(): ICorrespondenceChatContext {
  const ctx = useContext(CorrespondenceChatContext)
  if (!ctx) throw new Error('useCorrespondenceChat must be used within CorrespondenceChatProvider')
  return ctx
}
